import { render, staticRenderFns } from "./beneficiaryAdditionalInformation.vue?vue&type=template&id=f5f6e066&scoped=true&style=background%3A%20var(--v-muted-base)&"
import script from "./beneficiaryAdditionalInformation.vue?vue&type=script&lang=js&"
export * from "./beneficiaryAdditionalInformation.vue?vue&type=script&lang=js&"
import style0 from "./beneficiaryAdditionalInformation.vue?vue&type=style&index=0&id=f5f6e066&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f6e066",
  null
  
)

export default component.exports